/**
 * KonfiguratorVerwalter - Kapselt die JustSelling Logik
 */
class KonfiguratorVerwalter {
    constructor(options = {}) {
        this.token = options.token;
        this.templateId = options.templateId;
        this.customerId = options.customerId;
        this.taxRate = options.taxRate || "0";
        this.cloudBase = "cloud.justsellingapp.com";
        
        if (!this.token || !this.templateId) {
            console.error("KonfiguratorVerwalter: Fehlende Parameter!");
            return;
        }

        // Wartet, bis alle Ressourcen (Window) geladen sind
        this.waitForWindowLoad(() => this.init());
    }

    waitForWindowLoad(callback) {
        if (document.readyState === 'complete') {
            callback();
        } else {
            window.addEventListener('load', callback);
        }
    }

    init() {
        this.setupSettings();
        this.injectScript();
        this.setupLoaderImage();
        this.setHidden();
        this.startValueObservation();
    }

    setupSettings() {
        window._configentoSettings = window._configentoSettings || [];
        window._configentoSettings["_cloudbase"] = this.cloudBase;
        window._configentoSettings["_token"] = this.token;
        window._configentoSettings["_taxrate"] = this.taxRate;
        window._configentoSettings["_template"] = this.templateId;
        window._configentoSettings["_customer"] = this.customerId;
        window._configentoSettings["_cssPathCombinedImage"] = ".configento-combinedImage";
    }

    injectScript() {
        const scriptUrl = `https://${this.cloudBase}/configento/js/justselling/configento/plugin/html5.js`;
        
        if (document.querySelector(`script[src*="${this.cloudBase}"]`)) return;

        const script = document.createElement("script");
        script.type = "text/javascript";
        script.async = true;
        script.src = scriptUrl;
        document.head.appendChild(script);
    }

    setupLoaderImage() {
        const imageUrl = `https://${this.cloudBase}/configento/js/justselling/configento/assets/images/animation.gif`;
        const loader = document.getElementById("configurator1-loader");
        if (loader) loader.src = imageUrl;
    }

    setHidden() {
      document.querySelectorAll('[id^="Quantity-Form-"]').forEach((el) => {
        el.remove();
      });

    document.querySelectorAll('button.tabBtn').forEach(btn => {
      if (btn.textContent.trim().startsWith('produkttab_')) {
        btn.hidden = true;
      }
    });

      document.querySelectorAll('.product-form__buttons').forEach((el) => {
        el.hidden = true;
      });
    }

    startValueObservation() {
        const targetId = 'configurator1-header';
        const targetInput = document.getElementById(targetId);

        // Rekursion, falls das Feld noch nicht vom JustSelling-Script erzeugt wurde
        if (!targetInput) {
            setTimeout(() => this.startValueObservation(), 500);
            return;
        }

        console.log("Monitoring aktiv für:", targetId);
        document.querySelectorAll('.product-form__buttons').forEach((el) => {
          el.hidden = false;
        });

        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                if (mutation.attributeName === "value" && targetInput.value) {
                    this.handleDataChange(targetInput.value);
                }
            });
        });

        observer.observe(targetInput, { attributes: true });
    }

    handleDataChange(base64Value) {
        try {
            // Sicherer UTF-8 Decode:
            // 1. atob() dekodiert Base64 zu einem binären String
            // 2. escape() wandelt Sonderzeichen um
            // 3. decodeURIComponent() macht daraus sauberes UTF-8
            const utf8String = decodeURIComponent(escape(atob(base64Value)));
            const decoded = JSON.parse(utf8String);
            
            console.log("Konfiguration (UTF-8) dekodiert:", decoded);

            // Preis-Update Logik
            const priceData = decoded.rund_preis || decoded.price;
            if (priceData && priceData.price) {
                this.updatePriceDisplay(priceData.price);
            }
        } catch (e) {
            console.error("UTF-8 Dekodierungsfehler:", e);
        }
    }

    updatePriceDisplay(price) {
        const priceElement = document.getElementById('configento-price');
        if (priceElement) {
            priceElement.innerText = new Intl.NumberFormat('de-DE', { 
                style: 'currency', 
                currency: 'EUR' 
            }).format(price);
        }
    }
}